<template>
  <div>
    <div class="integratios-list-wrapper d-flex align-items-center gap-4 flex-wrap">
      <div
      :key="item.slug"
      v-for="item in integrations"
        class="integrations__modal-item-wrapper d-flex align-items-center justify-content-center shadow-sm border"
        :class="{ '--active bg-blue text-secondary': item.slug === innerSelectedIntegration }"
        @click="integrationItemClick(item)"
      >
        <div v-if="item.slug != 'simplify_ad'" class="integrations__modal-item">
          <img v-if="item.custom_img" class="logo-wrap-campaign" :src="item.custom_img" alt="brand-logo" />
          <i v-else :class="item.custom_icon || item.logo" style="font-size: 36px;"></i>
          <span class="integrarion-brand-name" style="text-align: center;">{{ item.custom_name || item.name }}</span>
        </div>
        <div v-else class="integrations__modal-item">
          <div class="integrations__modal-item">
            <i class="fa-solid fa-rectangle-ad" style="font-size: 36px;"></i>
            <span class="integrarion-brand-name" style="text-align: center;">Simplify AD</span>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-center shadow-sm add-new-integration-wrapper" @click="redirectToAddIntegration">
        <i class="fa-solid fa-plus" style="font-size: 36px;"></i>
        <span class="integrarion-brand-name">Add integration</span>
      </div>
    </div>

    <div class="mt-4">
      <!-- Google Sheet -->
      <div v-if="innerSelectedIntegration === 'googlesheet'">
        <div v-if="isGoogleInfoFetching || isLoadingResetSpreadsheet" class="row" v-loading="true" id="loading"></div>
        <div v-else>
          <base-input label="Client Emails Approved to View the Google Sheet:">
            <textarea
              class="w-100"
              v-model="value.report_sent_to"
              @keydown="handleKeydown"
              @paste="handlePaste"
              placeholder="Enter email, separate by new line"
              rows="4"
            ></textarea>
            <span>Seperate the emails by space or comma</span>
          </base-input>
          <div class="has-label" :style="{ display: userType === 'client' ? 'none' : 'block' }">
            <label>Admins Approved for Google Sheet Administration</label>
            <el-select multiple class="select-info select-fullwidth" size="large" v-model="value.admin_notify_to" placeholder="You can select multiple Admin">
              <el-option v-for="option in selectsAdministrator.administratorList" class="select-info" :value="option.id" :label="option.name" :key="option.id"></el-option>
            </el-select>
          </div>

          <div class="mt-3">
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="isLoadingSendTestSpreadsheet ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="onSendTestSpreadsheet" circle :disabled="isLoadingSendTestSpreadsheet"></el-button>
              <el-button type="text" :disabled="isLoadingSendTestSpreadsheet" @click="onSendTestSpreadsheet" style="margin-left: 0px;">Check Spreadsheet Connection</el-button>
            </div>
          </div>

          <div class="mt-3">
            <!-- MAIN SHEET -->
            <div v-if="value.spreadsheet_id" class="gsheet-grid mt-1">
              <a
                class="gsheet-item"
                :href="'https://docs.google.com/spreadsheets/d/' + value.spreadsheet_id + '/edit#gid=0'"
                target="_blank"
                style="text-decoration: none; color: #222a42 !important;"
              >
                <span>Open google sheet</span>
                <el-tooltip content="Go to Google Sheet" effect="light" :open-delay="300" placement="top">
                  <i class="fab fa-google-drive  ml-2" style="color:#6699CC"></i>
                </el-tooltip>
              </a>
            </div>

            <label v-if="filteredHistory.length" class="mt-3">History Spreadsheet</label>
            <!-- HISTORY SHEET -->
            <div v-if="filteredHistory.length" class="mt-2">
              <div class="history-grid">
                <a
                  v-for="(item, index) in filteredHistory"
                  :key="index"
                  class="history-item"
                  :href="'https://docs.google.com/spreadsheets/d/' + item.spreadsheet_id + '/edit#gid=0'"
                  target="_blank"
                  style="text-decoration: none; color: #222a42 !important;"
                >
                  <span class="history-label"> History {{ index + 1 }} ({{ item.created_at }}) </span>
                  <el-tooltip content="View this spreadsheet" effect="light" :open-delay="300" placement="top">
                    <i class="fab fa-google-drive ml-2" style="color:#CCCC66"></i>
                  </el-tooltip>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SendGrid -->
      <div v-if="innerSelectedIntegration === 'sendgrid'">
        <div v-if="isSendgridInfoFetching" class="row" v-loading="true" id="loading"></div>
        <div v-else-if="errors.sendgrid">
          <el-alert title="Connection Issue" type="warning" description="There seems to be a problem with your integration. Please check your connection settings and try again." :closable="false" show-icon />
        </div>
        <div v-else>
          <el-checkbox v-model="sendgrid_is_active">Connect to {{ nameIntegration }}</el-checkbox>
          <div class="d-flex mt-2" style="gap: 4px;">
            <div class="has-label flex-grow-1">
              <label class="mb-0">Choose Action</label>
              <el-select multiple class="select-info select-fullwidth" size="large" v-model="sendgrid_action" placeholder="You can select multiple actions">
                <el-option v-for="option in sendGridActionsOptions" class="select-info" :value="option.id" :label="option.name" :key="option.id" />
              </el-select>
            </div>

            <div v-if="sendgrid_action && sendgrid_action.includes('add-to-list')" class="flex-grow-1">
              <div class="warning-banner" v-if="sendGridListOptions.length < 1"><p>You don't have any active {{ nameIntegration }} list please create one</p></div>
              <div v-else class="has-label">
                <label class="mb-0">Choose {{ nameIntegration }} list</label>
                <el-select multiple class="select-info select-fullwidth" size="large" v-model="sendgrid_list" placeholder="You can select multiple actions">
                  <el-option v-for="option in sendGridListOptions" class="select-info" :value="option.id" :label="option.name" :key="option.id" />
                </el-select>
              </div>
            </div>
          </div>

          <base-input v-if="userType != 'client' && value.sendgrid_list && value.sendgrid_list.includes('send-mail')" label="Email format">
            <textarea class="w-100" v-model="ClientReportSentTo" placeholder="Enter email format" rows="4"></textarea>
          </base-input>
          <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="onSendTestLead" circle :disabled="isLoadingSendTestLead"></el-button>
              <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="'el-icon-view'" @click="onViewExampleData" circle></el-button>
              <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- GoHighLevel -->
      <div v-if="innerSelectedIntegration === 'gohighlevel'">
        <div v-if="isGoHighInfoFetching" class="row" v-loading="true" id="loading"></div>
 
        <div v-else-if="errors.goHighLevel">
          <el-alert title="Connection Issue" type="warning" description="There seems to be a problem with your integration. Please check your connection settings and try again." :closable="false" show-icon />
        </div>
        <div v-else>
          <el-checkbox v-model="ghl_is_active">Connect to {{ nameIntegration }}</el-checkbox>

          <div class="has-label mt-2" v-if="innerSelectedIntegration === 'gohighlevel'">
            <label class="mb-0">Choose Tags</label>
            <el-select
              ref="selectGhlTags"
              multiple
              allow-create
              filterable
              default-first-option
              :reserve-keyword="false"
              class="select-info select-fullwidth select-integration-ghl"
              size="large"
              v-model="ghl_tags"
              placeholder="You can select multiple tags"
              @change="changeGhlTags"
              @focus="changeGhlTags"
              @blur="changeGhlTags"
              @visible-change="changeGhlTags"
              @remove-tag="changeGhlTags"
              @clear="changeGhlTags"
            >
              <el-option v-for="option in goHighLevelTagsOptions" :value="option.id" :label="option.name" :key="option.id">
                <span class="ellipsis-text">{{ option.name }}</span>
              </el-option>
            </el-select>

            <div v-if="ghl_tags_remove.length > 0" class="mt-2 mb-2">
              <p class="m-0 p-0">*This tag has an error in {{ nameIntegration }}.</p>
            </div>
          </div>
          <div class="mt-3">
            <TagsAutomation :isLoadingTagsAutomation="isLoadingTagsAutomation" :isErrorTagsAutomation="isErrorTagsAutomation" :isActiveTagsAutomation="isActiveTagsAutomation" :onTagsAutomation="onTagsAutomation" />
          </div>
          <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="onSendTestLead" circle :disabled="isLoadingSendTestLead"></el-button>
              <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="'el-icon-view'" @click="onViewExampleData" circle></el-button>
              <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Kartra -->
      <div v-if="innerSelectedIntegration === 'kartra'">
        <div v-if="isKartraInfoFetching" class="row" v-loading="true" id="loading"></div>
        <div v-else-if="errors.kartra">
          <el-alert title="Connection Issue" type="warning" description="There seems to be a problem with your integration. Please check your connection settings and try again." :closable="false" show-icon />
        </div>
        <div v-else>
          <el-checkbox v-model="kartra_is_active">Connect to {{ nameIntegration }}</el-checkbox>
          <div class="d-flex mt-2" style="gap: 4px;">
            <div class="flex-grow-1">
              <div class="warning-banner" v-if="kartraListOptions.length < 1"><p>You don't have any active {{ nameIntegration }} list please create one</p></div>
              <div v-else class="has-label">
                <label class="mb-0">Choose {{ nameIntegration }} list</label>
                <el-select multiple class="select-info select-fullwidth" size="large" v-model="selectedKartraList" placeholder="You can select multiple lists">
                  <el-option v-for="option in kartraListOptions" class="select-info" :value="option" :label="option" :key="option" />
                </el-select>
              </div>
            </div>
            <div class="flex-grow-1">
              <div class="warning-banner" v-if="kartraTagsOptions.length < 1"><p>You don't have any active {{ nameIntegration }} Tags please create one</p></div>
              <div v-else class="has-label">
                <label class="mb-0">Choose {{ nameIntegration }} Tags</label>
                <el-select multiple class="select-info select-fullwidth" size="large" v-model="selectedKartraTags" placeholder="You can select multiple tags">
                  <el-option v-for="option in kartraTagsOptions" class="select-info" :value="option" :label="option" :key="option" />
                </el-select>
              </div>
            </div>
          </div>
          <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="onSendTestLead" circle :disabled="isLoadingSendTestLead"></el-button>
              <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="'el-icon-view'" @click="onViewExampleData" circle></el-button>
              <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Zapier -->
      <div v-if="innerSelectedIntegration === 'zapier'">
        <div v-if="isZapierFetching" class="row" v-loading="true" id="loading"></div>
        <div v-else-if="errors.webhook">
          <el-alert title="Connection Issue" type="warning" description="There seems to be a problem with your integration. Please check your connection settings and try again." :closable="false" show-icon />
        </div>
        <div v-else>
          <el-checkbox v-model="zapierEnable">Enable {{ nameIntegration }}</el-checkbox>
          <div class="has-label mt-2">
            <label class="mb-0">Enter your Webhook URL</label>
            <div style="display: flex; flex-direction: column; gap: 8px;">
              <div v-for="(url, index) in zapierWebhook" :key="index" class="webhook-url-wrapper">
                <el-input type="text" clearable label="Enter your Webhook URL" placeholder="https://hooks.app.com/hooks/catch/....." class="flex-grow-1 mb-0" v-model="zapierWebhook[index]" aria-controls="datatables"></el-input>
                <span v-if="index == 0" class="add-webhook-url" @click="addWebhookUrl">
                  <i class="fa-solid fa-plus"></i>
                </span>
                <span v-if="index != 0 && zapierWebhook.length > 1" class="add-webhook-url" @click="removeWebhookUrl(index)">
                  <i class="fa-solid fa-minus"></i>
                </span>
              </div>
            </div>
            <p v-if="defaultWebhook" class="mt-2">you're using <b>default</b> client webhook, replace URL if you want to use custom webhook for this campaign</p>
            <p v-if="!defaultWebhook" class="mt-2">you're using <b>custom</b> webhook, just delete this URL and save. if you want to use default webhook for this campaign</p>
            <label class="mb-0">Enter Tags</label>
            <el-select multiple allow-create filterable default-first-option :reserve-keyword="false" class="select-info select-fullwidth" size="large" v-model="zapierTags" placeholder="You can select multiple tags">
              <el-option v-for="option in zapierTagsOptions" class="select-info" :value="option.name" :label="option.name" :key="option.name" />
            </el-select>
          </div>
          <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="onSendTestLead" circle :disabled="isLoadingSendTestLead"></el-button>
              <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="'el-icon-view'" @click="onViewExampleData" circle></el-button>
              <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- MailboxPower -->
      <div v-if="innerSelectedIntegration === 'mailboxpower'">
        <div v-if="isMailBoxPowerFetching" class="row" v-loading="true" id="loading"></div>
        <div v-else-if="errors.mailboxPower">
          <el-alert title="Connection Issue" type="warning" description="There seems to be a problem with your integration. Please check your connection settings and try again." :closable="false" show-icon />
        </div>
        <div v-else>
          <el-checkbox v-model="mbp_is_active">Connect to {{ nameIntegration }}</el-checkbox>
          <div class="has-label mt-2" v-if="innerSelectedIntegration === 'mailboxpower'">
            <label class="mb-0">Choose Groups</label>
            <el-select multiple allow-create filterable default-first-option :reserve-keyword="false" class="select-info select-fullwidth" size="large" v-model="mbp_groups" placeholder="You can select multiple Groups">
              <el-option v-for="option in mailBoxPowerOptions" class="select-info" :value="option.id" :label="option.name" :key="option.id" />
            </el-select>

            <div class="row" style="padding-left: 16px; margin-bottom: 10px; margin-top: 10px;">
              <el-radio v-model="mbp_options" label="state">State</el-radio>
              <el-radio v-model="mbp_options" label="zip">Zip Code</el-radio>
            </div>

            <div v-if="mbp_options == 'state'">
              <label class="mb-0">Choose States</label>
              <el-select multiple :allow-create="false" filterable default-first-option :reserve-keyword="false" class="select-info select-fullwidth" size="large" v-model="mbp_states" placeholder="You can select states">
                <el-option v-for="option in mailBoxPowerStates" class="select-info" :value="option.state_code" :label="option.state" :key="option.sifi_state_id" />
              </el-select>
            </div>

            <div v-if="mbp_options == 'zip'">
              <label class="mb-0">Upload Zip Code</label>
              <div style="margin-top: 5px;">
                <form enctype="multipart/form-data" style="display: flex; justify-content: start; align-items: center; gap: 16px;">
                  <el-upload ref="mailBoxPowerZip" class="upload-demo" :show-file-list="false" :auto-upload="false" action="#" :name="mailBoxpowerUploadZipName" :on-change="mailBoxPowerFilesChange">
                    <el-button slot="trigger" size="small" type="primary">select file</el-button>
                  </el-upload>
                  <span><i v-if="isMailBoxPowerSavingZip" class="fas fa-spinner fa-spin" style="font-size: 16px; margin-top: 8px;"></i></span>
                </form>
              </div>
              <div class="row" style="margin-top: 3px;">
                <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                  <div class="form-group has-label">
                    <el-input class="mailboxzipcode" type="textarea" :rows="6" :resize="'none'" placeholder="" v-model="mbp_zip" @blur="removeEmptyLines"></el-input>
                  </div>
                </div>
              </div>
            </div>

            <p v-if="mbp_groups_remove.length > 0">Attention: The following tags have been removed from {{ nameIntegration }}:</p>
            <p v-for="(item, index) in mbp_groups_remove" :key="index">- {{ item }}</p>
          </div>
          <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="onSendTestLead" circle :disabled="isLoadingSendTestLead"></el-button>
              <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
            </div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-button size="medium" :icon="'el-icon-view'" @click="onViewExampleData" circle></el-button>
              <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- ClickFunnels -->
      <div v-if="innerSelectedIntegration === 'clickfunnels'">
        <div style="display: flex; gap: 16px;">
          <el-menu :default-active="menuClickFunnels" class="el-menu-vertical-demo" :collapse="isCollapseMenuClickFunnels">
            <el-menu-item index="choose-tag" @click="handleClickMenuClickFunnels('choose-tag')">
              <i class="el-icon-menu"></i>
              <span slot="title">Tag Selection</span>
            </el-menu-item>
            <el-menu-item index="create-tag" @click="handleClickMenuClickFunnels('create-tag')">
              <i class="el-icon-circle-plus"></i>
              <span slot="title">Create Tag</span>
            </el-menu-item>
          </el-menu>

          <div v-if="menuClickFunnels === 'choose-tag'" style="flex: 1; display: flex; flex-direction: column;">
            <div v-if="isLoadingGetTagsClickFunnels" class="row" v-loading="true" id="loading"></div>
            <div v-else-if="errors.clickfunnels">
              <el-alert title="Connection Issue" type="warning" description="There seems to be a problem with your integration. Please check your connection settings and try again." :closable="false" show-icon />
            </div>
            <div v-else>
              <p style="font-weight: 600; margin-bottom: 0px;">Tag Selection</p>
              <div style="margin-top: 16px;">
                <el-checkbox v-model="clickfunnels_is_active">Connect to {{ nameIntegration }}</el-checkbox>
                <p style="margin-bottom: 8px; margin-top: 16px;">Choose tags :</p>
                <el-select style="width: 100%;" v-model="listTagsClickFunnelsSelected" multiple placeholder="Select tags" value-key="id" class="click-funnels-tag-select">
                  <el-option v-for="item in listTagsClickFunnels" :key="item.id" :label="item.name" :value="item" :collapse-tags="false"> </el-option>
                </el-select>
                <div style="margin-top: 16px;">
                  <div v-if="isLoadingGetCampaignTagsClickFunnels" style="display: flex;">
                    <div v-for="n in 3" :key="n" class="skeleton-tag"></div>
                  </div>
                  <div v-else class="tags-container">
                    <div v-for="tag in listTagsClickFunnelsSelected" :key="tag.id" :style="{ backgroundColor: tag.color, color: getTextColor(tag.color), borderColor: tag.color }" class="tag-item">
                      <span class="tag-text">{{ tag.name }}</span>
                      <i class="el-icon-close close-icon" @click="removeTagClickFunnels(tag)"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <el-button size="medium" :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'" @click="onSendTestLead" circle :disabled="isLoadingSendTestLead"></el-button>
                  <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <el-button size="medium" :icon="'el-icon-view'" @click="onViewExampleData" circle></el-button>
                  <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="menuClickFunnels === 'create-tag'" style="flex: 1; display: flex; flex-direction: column;">
            <div>
              <p style="font-weight: 600; margin-bottom: 0px;">New Contact Tag</p>
              <el-form label-position="top" :model="formNewTagClickFunnels" ref="formNewTagClickFunnels">
                <el-form-item label="Name :" prop="name" :rules="[{ required: true, message: 'Name is required' }]"><el-input v-model="formNewTagClickFunnels.name" autocomplete="off"></el-input></el-form-item>
                <el-form-item label="Color :" prop="color" :rules="[{ required: true, message: 'Color is required' }]">
                  <p style="font-weight: 600; font-size: 12px;">{{ formNewTagClickFunnels.color }}</p>
                  <div style="display: flex; gap: 16px; flex-wrap: wrap;">
                    <span v-for="(color) in colorsNewTagClickFunnels" :key="color.value" @click="onColorClickFunnels(color.value)" :style="{backgroundColor: color.value, height: '40px', width: '40px', borderRadius: '4px', border: color.value === formNewTagClickFunnels.color ? '4px solid white' : '', boxShadow: color.value === formNewTagClickFunnels.color ? `0 0 0 4px ${color.value}` : '', cursor: 'pointer'}"></span>
                    <el-color-picker v-model="formNewTagClickFunnels.color"></el-color-picker>
                  </div>
                </el-form-item>
              </el-form>
              <base-button :disabled="isLoadingCreateTagsClickFunnels" @click="onCreateTagsClickFunnels" style="margin-top: 24px;" :style="{width: isLoadingCreateTagsClickFunnels ? '120px' : '100px'}">
                <i v-if="isLoadingCreateTagsClickFunnels" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i> Submit
              </base-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Agency Zoom -->
      <div v-if="innerSelectedIntegration === 'agencyzoom'" class="''">
        <div v-if="isAgencyZoomFetching" class="row" v-loading="true" id="loading"></div>
        <div v-else>
          <el-checkbox v-model="agencyZoomEnable">Enable {{ nameIntegration }}</el-checkbox>
          <div class="has-label mt-2">
              <label class="mb-0">Enter your Webhook URL</label>
              <div style="display: flex; flex-direction: column; gap: 8px;">
                  <div v-for="(url, index) in agencyZoomWebhook" :key="index" class="webhook-url-wrapper">
                      <el-input 
                        type="text" 
                        clearable 
                        label="Enter your Webhook URL"
                        placeholder="https://app.agencyzoom.com/v1/api/lead/webhook/....."
                        class="flex-grow-1 mb-0"
                        v-model="agencyZoomWebhook[index]"  
                        aria-controls="datatables">
                      </el-input>
                      <span 
                          v-if="index == 0" 
                          class="add-webhook-url" 
                          @click="addWebhookUrl('agencyzoom')">
                          <i class="fa-solid fa-plus"></i>
                      </span>
                      <span 
                          v-if="index != 0 && agencyZoomWebhook.length > 1" 
                          class="add-webhook-url" 
                          @click="removeWebhookUrl(index,'agencyzoom')">
                          <i class="fa-solid fa-minus"></i>
                      </span>
                  </div>
              </div>

              <p v-if="defaultAgencyZoomWebhook" class="mt-2">you are using <b>default</b> client webhook, replace URL if you want to use custom webhook for this campaign  </p>
              <p v-else class="mt-2">you are using <b>custom</b> webhook, just delete this URL and save. if you want to use default webhook for this campaign </p>
              
              <!-- <label  class="mb-0">Enter Tags</label>
              <el-select 
                  multiple 
                  allow-create
                  filterable
                  default-first-option
                  :reserve-keyword="false"
                  class="select-info select-fullwidth" 
                  size="large"
                  v-model="zapierTags" 
                  placeholder="You can select multiple tags">
                  <el-option v-for="option in zapierTagsOptions" class="select-info" :value="option.name"
                      :label="option.name" :key="option.name">
                  </el-option>
              </el-select> -->
              <!-- <label class="mt-2">Test Your Webhook ?</label>
              <el-checkbox v-model="zapierTestEnable" class="d-block">Send Test Data</el-checkbox>
              <p>* Please check the 'Send Test Data' checkbox and click 'Save' to send the test data to your Webhook.</p> -->
          </div>
        </div>
        <div class="mt-3" style="display: flex; flex-direction: row; gap: 10px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <el-button
            size="medium"
            :icon="isLoadingSendTestLead ? 'el-icon-loading' : 'el-icon-s-promotion'"
            @click="onSendTestLead"
            circle
            :disabled="isLoadingSendTestLead"
            ></el-button>
            <el-button type="text" :disabled="isLoadingSendTestLead" @click="onSendTestLead" style="margin-left: 0px;">Send Test Contact</el-button>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <el-button
            size="medium"
            :icon="'el-icon-view'"
            @click="onViewExampleData"
            circle
            ></el-button>
            <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
          </div>
        </div>
      </div>

      <div v-if="innerSelectedIntegration === 'simplify_ad'">
        <div v-if="isSimplifiFetching" class="row" v-loading="true" id="loading"></div>
        <div v-else>
          <el-checkbox v-model="simplifi_is_active">Connect to {{ nameIntegration }}</el-checkbox>
          <div class="has-label mt-2">
            <label class="mb-0">Choose Campaigns</label>
            <el-select
              ref="select-campaigns-simplify"
              multiple
              allow-create
              filterable
              default-first-option
              :reserve-keyword="false"
              class="select-info select-fullwidth select-integration-ghl"
              size="large"
              v-model="simplifiCampaignSelected"
              placeholder="You can select multiple tags">
              <el-option v-for="option in simplifiCampaignsOptions" :value="option.leadspeek_api_id" :label="option.campaign_name" :key="option.id">
                <span class="ellipsis-text">{{ option.campaign_name }}</span>
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Checkbox, Upload, Radio, Menu, MenuItem, Input, Form, FormItem, ColorPicker, Tooltip,Button ,Alert} from 'element-ui';
import TagsAutomation from './TagsAutomation.vue';
import swal from 'sweetalert2';
import { mapActions } from "vuex";

export default {
  name: 'IntegrationModalBody',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [Upload.name]: Upload,
    [Radio.name]: Radio,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [ColorPicker.name]: ColorPicker,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    [Alert.name]: Alert,
    TagsAutomation,
  },
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: Object, required: true },
    integrations: { type: Array, default: () => [] },
    selectedIntegration: { type: String, default: 'googlesheet' },
    userType: { type: String, default: '' },
    selectsAdministrator: { type: Object, default: () => ({ administratorList: [] }) },
  },
  data() {
    return {
      nameIntegration: '',
      innerSelectedIntegration: this.selectedIntegration,

      // Loading flags
      isLoadingSaveIntegration: false,
      isSendgridInfoFetching: false,
      isGoHighInfoFetching: false,
      isKartraInfoFetching: false,
      isZapierFetching: false,
      isMailBoxPowerFetching: false,
      isGoogleInfoFetching: false,
      isLoadingSendTestLead: false,
      isLoadingSendTestSpreadsheet: false,
      isLoadingResetSpreadsheet: false,

      // Options and state
      sendgrid_is_active: false,
      sendGridActionsOptions: [
        { id: 'add-to-list', name: 'Add to list' },
        { id: 'create-contact', name: 'Create a contact' },
      ],
      sendGridListOptions: [],
      sendgrid_action: [],
      sendgrid_list: [],

      ghl_is_active: false,
      goHighLevelTagsOptions: [],
      ghl_tags: [],
      ghl_tags_remove: [],
      isLoadingTagsAutomation: false,
      isErrorTagsAutomation: false,
      isActiveTagsAutomation: false,

      kartra_is_active: false,
      kartraTagsOptions: [],
      kartraListOptions: [],
      selectedKartraList: [],
      selectedKartraTags: [],

      zapierEnable: false,
      zapierTestEnable: false,
      zapierTags: [],
      zapierTagsOptions: [],
      zapierWebhook: [''],
      defaultWebhook: true,

      mbp_is_active: false,
      mailBoxPowerOptions: [],
      mailBoxPowerStates: [],
      mbp_groups: [],
      mbp_groups_remove: [],
      mbp_states: [],
      mbp_zip: '',
      mbp_options: 'state',
      mailBoxpowerUploadZipName: 'mailboxpoweupload',
      isMailBoxPowerSavingZip: false,

      agencyZoomEnable: false,
      agencyZoomTestEnable: false,
      agencyZoomWebhook: [''],
      defaultAgencyZoomWebhook: false, 
      isAgencyZoomFetching: false,

      simplifi_is_active: false,
      simplifiCampaignSelected: [],
      simplifiCampaignsOptions: [],
      isSimplifiFetching: false,

      // ClickFunnels
      clickfunnels_is_active: false,
      menuClickFunnels: 'choose-tag',
      listTagsClickFunnels: [],
      listTagsClickFunnelsSelected: [],
      isLoadingGetTagsClickFunnels: false,
      isLoadingCreateTagsClickFunnels: false,
      isLoadingGetCampaignTagsClickFunnels: false,
      isCollapseMenuClickFunnels: window.innerWidth < 768,
      formNewTagClickFunnels: { name: '', color: '' },
      colorsNewTagClickFunnels: [
        { value: '#ffd400' },
        { value: '#9c27b0' },
        { value: '#00bcd4' },
        { value: '#ff5722' },
        { value: '#4caf50' },
        { value: '#f2593d' },
        { value: '#f68421' },
        { value: '#f9de00' },
        { value: '#929292' },
        { value: '#5645ef' },
      ],

      // Misc
      ClientReportSentTo: '',
      spreadsheetHistory: [],
      advanceExampleDataUrl: 'https://sitesettings-api-docs.vercel.app/agency/informations/send-test',
      windowWidth: window.innerWidth,
      errors: {
        sendgrid: false,
        mailboxPower: false,
        goHighLevel: false,
        webhook: false,
        kartra: false,
        clickfunnels: false,
      },
    };
  },
  computed: {
    filteredHistory() {
      return this.spreadsheetHistory || [];
    },
  },
  watch: {
    selectedIntegration(val) {
      if (val !== this.innerSelectedIntegration) {
        this.innerSelectedIntegration = val;
      }
    },
    innerSelectedIntegration(val) {
      this.$emit('update:selectedIntegration', val);
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    ...mapActions(["getCampaignAgencyZoomDetails","getClientAgencyZoometails"]),
    // Save entry point for parent
    async save() {
      try {
        this.isLoadingSaveIntegration = true;
        this.$emit('loading-change', true);

        let data = {
          id: this.value.id,
          company_id: this.value.company_parent,
          integration_slug: this.innerSelectedIntegration,
        };

        if (this.innerSelectedIntegration === 'googlesheet') {
          data.reportSentTo = this.value.report_sent_to;
          data.adminNotifyTo = this.value.admin_notify_to;
        } else if (this.innerSelectedIntegration === 'sendgrid') {
          data.sendgrid_action = this.value.sendgrid_action;
          data.sendgrid_list = this.value.sendgrid_list ? this.value.sendgrid_list : [];
          data.sendgrid_is_active = this.value.sendgrid_is_active ? 1 : 0;
        } else if (this.innerSelectedIntegration === 'gohighlevel') {
          data.ghl_tags = this.ghl_tags;
          data.ghl_is_active = this.value.ghl_is_active ? 1 : 0;
          data.company_parent_id = this.value.company_id;
          data.leadspeek_api_id = this.value.leadspeek_api_id;
          data.status_keyword_to_tags = this.isActiveTagsAutomation;
        } else if (this.innerSelectedIntegration === 'kartra') {
          data.tag = this.selectedKartraTags;
          data.list = this.selectedKartraList;
          data.kartra_is_active = this.value.ghl_is_active ? 1 : 0;
        } else if (this.innerSelectedIntegration === 'zapier') {
          data.zapier_webhook = this.zapierWebhook;
          data.zapier_tags = this.zapierTags;
          data.zapier_is_active = this.zapierEnable ? 1 : 0;
          data.zapier_test_enable = this.zapierTestEnable ? 1 : 0;
          data.leadspeek_api_id = this.value.leadspeek_api_id;
          data.campaign_type = 'enhance';
          data.company_id_zap = this.value.company_id;
        } else if (this.innerSelectedIntegration === 'mailboxpower') {
          data.mbp_groups = this.mbp_groups;
          data.mbp_states = this.mbp_states;
          data.mbp_zip = this.mbp_zip;
          data.mbp_options = this.mbp_options;
          data.mbp_is_active = this.value.mbp_is_active ? 1 : 0;
          data.company_parent_id = this.value.company_id;
          data.leadspeek_api_id = this.value.leadspeek_api_id;
        } else if (this.innerSelectedIntegration === 'clickfunnels') {
          const listIdTagsClickFunnelsSelected = this.listTagsClickFunnelsSelected.map((tag) => tag.id);
          data.company_parent_id = this.value.company_id;
          data.clickfunnels_is_active = this.value.clickfunnels_is_active ? 1 : 0;
          data.clickfunnels_tags = listIdTagsClickFunnelsSelected;
        }

        await this.$store.dispatch('updateCompanyIntegrationConfiguration', { data });
        this.$emit('saved');
        this.$emit('close');
      } catch (e) {
        // handled by notifications in actions most likely
      } finally {
        this.isLoadingSaveIntegration = false;
        this.$emit('loading-change', false);
      }
    },

    async integrationItemClick(item) {
      this.nameIntegration = item.custom_name || item.name;
      if (item.slug === this.innerSelectedIntegration) return;
      this.innerSelectedIntegration = item.slug;

      if (this.innerSelectedIntegration === 'sendgrid') {
        this.isSendgridInfoFetching = true;
        this.errors.sendgrid = false;
        this.value.sendgrid_action = [];
        this.value.sendgrid_list = [];
        try {
          const res = await this.$store.dispatch('getUserSendgridList', { companyID: this.value.company_id });
          if (!res || res.error) {
            this.errors.sendgrid = true;
          } else {
            this.sendGridListOptions = res;
          }
        } catch (e) {
          this.errors.sendgrid = true;
        } finally {
          this.isSendgridInfoFetching = false;
        }
      } else if (this.innerSelectedIntegration === 'gohighlevel') {
        this.isGoHighInfoFetching = true;
        this.errors.goHighLevel = false;
        this.ghl_tags = [];
        this.ghl_tags_remove = [];
        this.value.ghl_is_active = 0;
        try {
          const response = await this.$store.dispatch('getGoHighLevelTags', { companyID: this.value.company_id });
          this.goHighLevelTagsOptions = (response.param && response.param.tags ? response.param.tags : []).map((item) => ({ id: item.id + '|' + item.name, name: item.name }));

          const userTags = await this.$store.dispatch('getGhlUserTags', {
            campaignID: this.value.leadspeek_api_id,
            companyID: this.value.company_id,
            userIP: this.$store.getters.userData.ip_login,
          });
          this.ghl_tags = [];
          (userTags.param || []).map((item) => {
            if (typeof item.id == 'undefined') {
              this.ghl_tags.push(item.name);
            } else {
              this.ghl_tags.push(item.id + '|' + item.name);
            }
          });
          this.value.ghl_is_active = userTags.ghlactive === 1;
          this.ghl_tags_remove = userTags.tagremove || [];

          this.$nextTick(() => {
            const inputGhlTags = this.$refs.selectGhlTags && this.$refs.selectGhlTags.$el.querySelector('.select-integration-ghl .el-select__input');
            if (inputGhlTags) inputGhlTags.addEventListener('keyup', this.keydownInputGhlTags);
            this.changeGhlTags('getGhlUserTags');
          });

          // Load automation status when base data succeeded
          await this.getStatusKeywordToTags('gohighlevel');
        } catch (e) {
          this.errors.goHighLevel = true;
        } finally {
          this.isGoHighInfoFetching = false;
        }
      } else if (this.innerSelectedIntegration === 'kartra') {
        this.onKartraIntegrationSelect();
      } else if (this.innerSelectedIntegration === 'googlesheet') {
        this.isGoogleInfoFetching = true;
        try {
          this.sendGridListOptions = await this.$store.dispatch('getUserSendgridList', { companyID: this.value.company_id });
          if (this.value && this.value.leadspeek_api_id) {
            this.getHistorySpreadsheet(this.value.leadspeek_api_id);
          }
        } finally {
          this.isGoogleInfoFetching = false;
        }
      } else if (this.innerSelectedIntegration === 'zapier') {
        this.isZapierFetching = true;
        try {
          const campaign_webhook = await this.$store.dispatch('getCampaignZapierDetails', { campaign_id: this.value.id });
          const campaign_tags = await this.$store.dispatch('getCampaignZapierTags', { campaign_id: this.value.id });
          const agency_webhook = await this.$store.dispatch('getAgencyZapierDetails', { company_id: this.value.company_id });
          const agency_tags = await this.$store.dispatch('getAgencyZapierTags', { company_id: this.value.company_id });

          this.zapierTagsOptions = [];
          if (agency_tags) {
            this.zapierTagsOptions = agency_tags.map((item) => ({ name: item.name }));
          }

          if (campaign_webhook.zap_webhook != '' && campaign_webhook.zap_webhook != null && campaign_webhook.zap_webhook != agency_webhook.api_key) {
            this.defaultWebhook = false;
            this.zapierEnable = campaign_webhook.zap_is_active === 1;
            this.zapierWebhook = campaign_webhook.zap_webhook;
            this.zapierTags = [];
            if (campaign_tags.zap_tags) {
              campaign_tags.zap_tags.map((item) => this.zapierTags.push(item.name));
            }
          } else {
            this.defaultWebhook = true;
            this.zapierEnable = campaign_webhook.zap_is_active === 1;
            if (agency_webhook[0] && agency_webhook[0].api_key) {
              this.zapierWebhook = [];
              agency_webhook[0].api_key.forEach((item) => this.zapierWebhook.push(item));
            }
            this.zapierTags = [];
            if (campaign_tags.zap_tags) {
              campaign_tags.zap_tags.map((item) => this.zapierTags.push(item.name));
            }
          }
        } catch (e) {
          console.log(e);
          this.errors.webhook = true;
        } finally {
          this.isZapierFetching = false;
        }
      } else if (this.innerSelectedIntegration === 'mailboxpower') {
        this.isMailBoxPowerFetching = true;
        this.errors.mailboxPower = false;
        this.mbp_groups = [];
        this.mbp_groups_remove = [];
        this.value.mbp_is_active = 0;

        this.$store
          .dispatch('getMailBoxPowerGroups', {
            companyID: this.value.company_id,
            campaignID: this.value.leadspeek_api_id,
          })
          .then((response) => {
            this.mailBoxPowerOptions = response.param.map((item) => ({ id: item.ID + '|' + item.NAME, name: item.NAME }));
            this.mailBoxPowerStates = response.states;
            this.$store
              .dispatch('getMailBoxPowerUserGroups', {
                campaignID: this.value.leadspeek_api_id,
                companyID: this.value.company_id,
              })
              .then(
                (response) => {
                  this.mbp_groups = [];
                  if (Array.isArray(response.param)) {
                    response.param.map((item) => this.mbp_groups.push(item.id + '|' + item.name));
                  }
                  this.mbp_states = response.mbpstates && Array.isArray(response.mbpstates) ? response.mbpstates : [];
                  this.mbp_zip = response.mbpzip && Array.isArray(response.mbpzip) ? response.mbpzip : '';
                  this.mbp_options = response.mbpoptions ? response.mbpoptions : 'state';
                  this.value.mbp_is_active = (response.mbpactive && response.mbpactive === 1);
                  this.mbp_groups_remove = response.mbpremove && Array.isArray(response.mbpremove) ? response.mbpremove : [];
                  this.isMailBoxPowerFetching = false;
                },
                () => {
                  this.isMailBoxPowerFetching = false;
                  this.errors.mailboxPower = true;
                },
              );
          })
          .catch(() => {
            this.isMailBoxPowerFetching = false;
            this.errors.mailboxPower = true;
          });
      } else if (this.innerSelectedIntegration === 'clickfunnels') {
        this.getListTagsClickFunnels();
      } else if (this.innerSelectedIntegration === 'agencyzoom') {
        this.isAgencyZoomFetching = true;
        const campaign_webhook = await this.getCampaignAgencyZoomDetails({campaign_id: this.value.id})
        const client_webhook = await this.getClientAgencyZoometails({ company_id: this.value.company_id})
        // console.log({campaign_webhook,client_webhook});

        this.leadspeek_api_id = this.value.leadspeek_api_id;
        this.agencyZoomEnable = campaign_webhook.agencyzoom_is_active === 1;
        this.agencyZoomWebhook = [];

        if ((campaign_webhook.agencyzoom_webhook != '' && campaign_webhook.agencyzoom_webhook != null) && campaign_webhook.agencyzoom_webhook != client_webhook[0].api_key) {
          this.defaultAgencyZoomWebhook = false;
          this.agencyZoomWebhook = campaign_webhook.agencyzoom_webhook;
        } else {
          this.defaultAgencyZoomWebhook = true;
          if (client_webhook[0] && client_webhook[0].api_key) {
            client_webhook[0].api_key.forEach(item => {
              this.agencyZoomWebhook.push(item);
            });
          }
        }

        this.isAgencyZoomFetching = false;
      } else if (this.innerSelectedIntegration === 'simplify_ad') {
        this.getSimplifiCampaigns()
      }
    },

    async onKartraIntegrationSelect() {
      this.isKartraInfoFetching = true;
      this.errors.kartra = false;
      this.selectedKartraList = [];
      this.selectedKartraTags = [];
      try {
        const data = { campaign_id: this.value.id, company_id: this.value.company_parent, integration_slug: this.innerSelectedIntegration };
        const res = await this.$store.dispatch('geUsertKartraDetails', { companyID: this.value.company_id });
        if (!res || res.error) {
          this.errors.kartra = true;
          return;
        }
        const resListandTag = await this.$store.dispatch('getSelectedKartraListAndTags', { data });
        this.value.ghl_is_active = resListandTag.data.kartra_is_active === 1;
        this.selectedKartraTags = resListandTag.data.tag;
        this.selectedKartraList = resListandTag.data.list;
        this.kartraTagsOptions = res.tags ? res.tags : [];
        this.kartraListOptions = res.lists ? res.lists : [];
      } catch (e) {
        this.errors.kartra = true;
      } finally {
        this.isKartraInfoFetching = false;
      }
    },

    redirectToAddIntegration() {
      if (this.$store.getters.userData.user_type === 'client') {
        this.$router.push({ name: 'Integration List' });
      } else {
        this.$router.push({ name: 'Client List' });
      }
    },

    changeGhlTags() {
      this.$nextTick(() => {
        document.querySelectorAll('.select-integration-ghl .el-tag.el-tag--info.el-tag--small.el-tag--light').forEach((element) => {
          const textOption = element.querySelector('.el-select__tags-text').textContent.trim();
          if (this.ghl_tags_remove.includes(textOption)) {
            element.classList.add('red-tag');
          } else {
            element.classList.remove('red-tag');
          }
        });
      });
    },
    keydownInputGhlTags() {
      this.changeGhlTags();
    },

    addWebhookUrl() {
      this.zapierWebhook.push('');
    },
    removeWebhookUrl(index) {
      this.zapierWebhook.splice(index, 1);
    },

    mailBoxPowerFilesChange(file) {
      // Placeholder for upload handler logic if needed later
      this.isMailBoxPowerSavingZip = false;
    },
    removeEmptyLines() {
      const lines = this.mbp_zip.split('\n').filter((line) => line.trim() !== '');
      this.mbp_zip = lines.join('\n');
    },

    onViewExampleData() {
      window.open(this.advanceExampleDataUrl, '_blank');
    },
    onSendTestLead() {
      this.isLoadingSendTestLead = true;
      const payload = {
        type: this.innerSelectedIntegration,
        date: this.$moment().format('YYYY-MM-DD'),
        company_id: this.value.company_id,
        campaign_id: this.value.leadspeek_api_id,
        format: {
          home_address_enabled: this.value.homeaddressenabled,
          phone_enabled: this.value.phoneenabled,
        },
      };

      if (this.innerSelectedIntegration == 'gohighlevel') {
        if (this.ghl_tags.length > 0) {
          const tags_go_high_level = this.ghl_tags.map((item) => (item.includes('|') ? item.split('|')[1] : item));
          payload.tags_go_high_level = tags_go_high_level;
        }
        payload.status_keyword_to_tags = this.isActiveTagsAutomation;
      } else if (this.innerSelectedIntegration == 'sendgrid') {
        if (this.value.sendgrid_action && this.value.sendgrid_action.includes('add-to-list')) {
          payload.sendgrid_list = this.value.sendgrid_list;
        }
      } else if (this.innerSelectedIntegration == 'mailboxpower') {
        if (this.mbp_groups.length > 0) {
          const group_mail_box_power = this.mbp_groups.map((item) => item.split('|')[0]).filter(Boolean);
          const new_group_mail_box_power = this.mbp_groups.filter((item) => !item.includes('|'));
          if (new_group_mail_box_power.length > 0) payload.new_group_mail_box_power = new_group_mail_box_power;
          payload.group_mail_box_power = group_mail_box_power;
        }
      } else if (this.innerSelectedIntegration == 'zapier') {
        payload.webhook_url = this.zapierWebhook;
        payload.webhook_tags = this.zapierTags;
      } else if (this.innerSelectedIntegration == 'kartra') {
        payload.campaign_id = this.value.id;
        payload.kartra_list = this.selectedKartraList;
        payload.kartra_tags = this.selectedKartraTags;
        payload.date = this.$moment().format('YYYY-MM-DD');
      } else if (this.innerSelectedIntegration == 'clickfunnels') {
        const listIdTagsClickFunnelsSelected = this.listTagsClickFunnelsSelected.map((tag) => tag.id);
        payload.clickfunnels_tags = listIdTagsClickFunnelsSelected;
      }

      this.$store.dispatch('onSendTestLead', payload).then(
        () => {
          this.$notify({ type: 'success', message: 'Sent test contact successfully!', icon: 'far fa-save' });
          this.isLoadingSendTestLead = false;
        },
        (err) => {
          this.isLoadingSendTestLead = false;
          this.$notify({ type: 'danger', message: err.message, icon: 'fas fa-exclamation-circle' });
        },
      );
    },

    async onSendTestSpreadsheet() {
      this.isLoadingSendTestSpreadsheet = true;
      this.$store
        .dispatch('onSendTestSpreadsheet', { campaignID: this.value.id })
        .then(
          (response) => {
            this.isLoadingSendTestSpreadsheet = false;
            if (response.data.result == 'success') {
              this.$notify({ type: response.data.result, message: response.data.message, icon: 'far fa-check' });
            } else {
              const status = response.data.status || 'UNKNOWN';
              swal
                .fire({
                  title: `<span style='font-size:21px;'><b>Spreadsheet Connection Failed</b><br><br><span style='font-size:16px;'>We couldn’t connect to the spreadsheet. It may belong to a different Google account. <br>Please switch to the correct account in the General Settings, or create a new spreadsheet to begin writing data. <br><br><span style='font-size:13px;'>Reason: ${status}</span></span></span>`,
                  text: '',
                  icon: '',
                  width: '600px',
                  showCancelButton: true,
                  customClass: { confirmButton: 'btn btn-fill mr-3', cancelButton: 'btn btn-danger btn-fill' },
                  confirmButtonText: 'Create New Spreadsheet',
                  buttonsStyling: false,
                })
                .then((result) => {
                  if (result.isConfirmed) this.resetSpreadsheet(this.value.id, this.value.leadspeek_api_id);
                });
            }
          },
          () => {
            this.isLoadingSendTestSpreadsheet = false;
            this.$notify({ type: 'danger', message: `Spreadsheet connection failed. Please ensure your Google account is connected in the General Settings menu.`, icon: 'far fa-warning' });
          },
        );
    },

    resetSpreadsheet(id) {
      this.isLoadingResetSpreadsheet = true;
      this.$store
        .dispatch('onResetSpreadsheet', { campaignID: id })
        .then(
          (response) => {
            this.isLoadingResetSpreadsheet = false;
            if (response.data.result == 'success') {
              this.$notify({ type: 'success', message: 'Reset Spreadsheet successfully', icon: 'far fa-save' });
            } else {
              this.$notify({ type: response.data.result, message: response.data.message, icon: 'far fa-info' });
            }
            this.$emit('close');
          },
          () => {
            this.isLoadingResetSpreadsheet = false;
            this.$notify({ type: 'error', message: 'Reset Spreadsheet Error. Try Again', icon: 'far fa-warning' });
            this.$emit('close');
          },
        );
    },

    getHistorySpreadsheet(leadspeek_api_id) {
      this.$store.dispatch('getHistorySpreadsheet', { campaignID: leadspeek_api_id }).then((response) => {
        this.spreadsheetHistory = response.data;
      });
    },

    handleClickMenuClickFunnels(value) {
      if (this.menuClickFunnels === value) return;
      if (value == 'choose-tag') this.getListTagsClickFunnels();
      this.menuClickFunnels = value;
    },
    onColorClickFunnels(value) {
      this.formNewTagClickFunnels.color = value;
      if (this.$refs.formNewTagClickFunnels) this.$refs.formNewTagClickFunnels.clearValidate(['color']);
    },
    removeTagClickFunnels(tag) {
      this.listTagsClickFunnelsSelected = this.listTagsClickFunnelsSelected.filter((t) => t.id !== tag.id);
    },
    getSimplifiCampaigns() {
      let _groupCompanyID = '';
      if ((localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '')){
        _groupCompanyID = localStorage.getItem('companyGroupSelected');
      }

      this.simplifiCampaignsOptions = []
      this.$store.dispatch('GetLeadsPeekClientList', {
        companyID: this.value.company_parent,
        leadspeekType: 'simplifi',
        groupCompanyID: _groupCompanyID,
        view: 'campaign',
      }).then(response => {
        this.simplifiCampaignsOptions = response;
        // console.log('GetLeadsPeekClientList', {
        //   'this.simplifiCampaignsOptions': this.simplifiCampaignsOptions
        // });
      },error => {
          
      });
      /** GET CLIENT LIST */
    },
    getListTagsClickFunnels() {
      this.isLoadingGetTagsClickFunnels = true;
      this.errors.clickfunnels = false;
      const payload = { company_id: this.value.company_id };
      this.$store.dispatch('getListTagsClickFunnels', payload).then(
        (response) => {
          this.listTagsClickFunnels = response.data;
          this.isLoadingGetTagsClickFunnels = false;
          this.getCampaignTagsClickFunnels();
        },
        () => {
          this.errors.clickfunnels = true;
          this.isLoadingGetTagsClickFunnels = false;
        },
      );
    },
    getCampaignTagsClickFunnels() {
      this.isLoadingGetCampaignTagsClickFunnels = true;
      const payload = { campaign_id: this.value.id };
      this.$store.dispatch('getCampaignTagsClickFunnels', payload).then(
        (response) => {
          const tagId = response.data.clickfunnels_tags ? response.data.clickfunnels_tags : [];
          const filterTags = this.listTagsClickFunnels.filter((tag) => tagId.includes(tag.id));
          this.listTagsClickFunnelsSelected = filterTags;
          this.value.clickfunnels_is_active = response.data.clickfunnels_is_active === 1;
          this.isLoadingGetCampaignTagsClickFunnels = false;
        },
        () => {
          this.errors.clickfunnels = true;
          this.isLoadingGetCampaignTagsClickFunnels = false;
        },
      );
    },
    onCreateTagsClickFunnels() {
      if (!this.formNewTagClickFunnels.name.trim()) {
        this.$refs.formNewTagClickFunnels && this.$refs.formNewTagClickFunnels.validateField(['name']);
        return;
      }
      if (!this.formNewTagClickFunnels.color.trim()) {
        this.$refs.formNewTagClickFunnels && this.$refs.formNewTagClickFunnels.validateField(['color']);
        return;
      }
      this.isLoadingCreateTagsClickFunnels = true;
      const payload = {
        company_id: this.value.company_id,
        name: this.formNewTagClickFunnels.name,
        color: this.formNewTagClickFunnels.color,
      };
      this.$store.dispatch('createTagsClickFunnels', payload).then(
        (response) => {
          this.isLoadingCreateTagsClickFunnels = false;
          this.$notify({ type: 'success', message: `${response.message} ${response.data.name}` });
          this.$refs.formNewTagClickFunnels && this.$refs.formNewTagClickFunnels.resetFields();
          this.formNewTagClickFunnels.name = '';
          this.formNewTagClickFunnels.color = '';
        },
        (error) => {
          this.$notify({ type: 'danger', message: error.message });
          this.isLoadingCreateTagsClickFunnels = false;
        },
      );
    },

    getTextColor(backgroundColor) {
      const rgb = this.hexToRgb(backgroundColor);
      const luminance = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
      return luminance > 0.5 ? '#000' : '#fff';
    },
    hexToRgb(hex) {
      const match = hex.match(/^#([0-9a-fA-F]{6})$/);
      if (match) {
        const r = parseInt(match[1].substring(0, 2), 16);
        const g = parseInt(match[1].substring(2, 4), 16);
        const b = parseInt(match[1].substring(4, 6), 16);
        return { r, g, b };
      }
      return { r: 255, g: 255, b: 255 };
    },
    handleWindowResize() {
      this.isCollapseMenuClickFunnels = window.innerWidth < 768;
      this.windowWidth = window.innerWidth;
    },
    async getStatusKeywordToTags(slug) {
      const params = { leadspeek_api_id: this.value.leadspeek_api_id, slug };
      this.isLoadingTagsAutomation = true;
      this.isActiveTagsAutomation = false;
      this.isErrorTagsAutomation = false;
      await this.$store
        .dispatch('getStatusKeywordToTags', params)
        .then((response) => {
          this.isActiveTagsAutomation = response.data;
          this.isLoadingTagsAutomation = false;
        })
        .catch(() => {
          this.isErrorTagsAutomation = true;
          this.isLoadingTagsAutomation = false;
        });
    },
    onTagsAutomation() {
      this.isActiveTagsAutomation = !this.isActiveTagsAutomation;
      this.changeGhlTags();
    },

    handleKeydown(event) {
      if (event.key === ' ') {
        event.preventDefault();
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const val = textarea.value;
        textarea.value = val.substring(0, start) + '\n' + val.substring(end);
        textarea.selectionStart = textarea.selectionEnd = start + 1;
        this.$emit('input', this.value);
      }
    },
    handlePaste(event) {
      const pastedData = (event.clipboardData || window.clipboardData).getData('text');
      if (!pastedData) return;
      event.preventDefault();
      const emails = pastedData.replace(/,/g, '\n').replace(/\s+/g, '\n');
      const textarea = event.target;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const val = textarea.value;
      textarea.value = val.substring(0, start) + emails + val.substring(end);
      textarea.selectionStart = textarea.selectionEnd = start + emails.length;
      this.$emit('input', this.value);
    },
  },
};
</script>

<style scoped>
/* Minimal styling reuse; rely on parent/global styles */
</style>
